import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cookie from 'js-cookie';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Elements } from 'react-stripe-elements';
import { withSizes } from 'react-sizes';
import { withRouter } from 'next/router';
import { updateProduct, updateProductPrice } from '../../redux/actions';
import { PaymentWizard, HotelPanel, SessionTimer, PaymentForm } from "../index";

import { Gold } from "../../utils";
import {
  CheckoutContainer,
  Column,
  PageHeading,
  Heading,
  ScoreContainer,
  ScoreIcon,
  ScoreDescription
} from './styles';

const mapStateToProps = state => ({
  product: state.userProduct,
  checkInDatePayment: state.bookingManagement.changeCheckingDate.isPaying,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handlePriceUpdate: updateProductPrice,
  handleProductUpdate: updateProduct,
}, dispatch);

const mapSizesToProps = ({ width }) => ({
  isMobile: width <= 768,
});

@withSizes(mapSizesToProps)
@connect(mapStateToProps, mapDispatchToProps)
@withRouter
class CheckoutPageWrapper extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    checkInDatePayment: PropTypes.bool,
    product: PropTypes.instanceOf(Object),
    handlePriceUpdate: PropTypes.func,
    handleProductUpdate: PropTypes.func,
    router: PropTypes.instanceOf(Object),
  };

  onTimeExpiry = () => {
    const { router } = this.props;
    const searchPage = localStorage.getItem('searchPage');
    const defaultUrl = '/';

    if (searchPage) {
      try {
        const [url, urlAs] = JSON.parse(searchPage);
        router.push(url, urlAs);
      } catch(err) {
        router.push(defaultUrl);
      }
    } else {
      router.push(defaultUrl);
    }
  };

  render() {
    const { onTimeExpiry } = this;
    const { isMobile, product, handlePriceUpdate, handleProductUpdate, checkInDatePayment, router } = this.props;
    let sessionExp;

    const userProduct = localStorage.getItem('userSession');
    const alreadyBooked = Cookie.get('booked');
    const redirectRoute = Cookie.get('ch_ref');


    if (alreadyBooked || window && window.history.length === 1 || redirectRoute === router.asPath) {
      sessionExp = new Date(Date.now() + (5 * 60 * 1000));
    } else {
      sessionExp = userProduct && !checkInDatePayment ? JSON.parse(userProduct).sessionExp : new Date(Date.now() + (5 * 60 * 1000));
    }

    return (
      <CheckoutContainer as="main">
        <Column>
          {!isMobile && (
            <PageHeading>
              <Heading>Confirm and pay</Heading>
              {typeof window !== 'undefined' && <SessionTimer product={product.product.name} endDate={sessionExp} onTimeExpiry={onTimeExpiry} />}
              <ScoreContainer>
                <ScoreIcon>
                  <Gold />
                </ScoreIcon>
                <ScoreDescription>
                  <span>What a score!</span> This is a very popular pass. Usually this hotel is booked. And now is the best price! Book it while its still available!
                </ScoreDescription>
              </ScoreContainer>
            </PageHeading>
          )}
          <Elements>
            <PaymentForm>
              <PaymentWizard />
            </PaymentForm>
          </Elements>
        </Column>
        <Column>
          {isMobile && (
            <PageHeading>
              <Heading>Confirm and pay</Heading>
              {typeof window !== 'undefined' && <SessionTimer product={product.product.name} endDate={sessionExp} onTimeExpiry={onTimeExpiry} />}
              <ScoreContainer>
                <ScoreIcon>
                  <Gold />
                </ScoreIcon>
                <ScoreDescription>
                  <span>What a score!</span> This is a very popular place. Rather, book it. Usually the place is reserved. Also now is the best price. Hurry up!
                </ScoreDescription>
              </ScoreContainer>
            </PageHeading>
          )}
          <HotelPanel
            checkoutPage
            hotelInfo={product.hotel}
            products={product.hotel.products}
            product={product.product}
            handleProductChange={handleProductUpdate}
            handleDateChange={handlePriceUpdate}
            totalReviews={product.hotel.reviews}
            rating={product.hotel.rating}
          />
        </Column>
      </CheckoutContainer>
    );
  }
}

export default CheckoutPageWrapper;
